import React from "react";
import ReceiptLibraryPage from "components/common/receiptLibrary/ReceiptLibraryPage";

const EmployeeReceiptLibrary: React.FC = () => <ReceiptLibraryPage mine />;

export default EmployeeReceiptLibrary;
